import React from 'react';
import PropTypes from 'prop-types';

import BEM from '@scripts/utilities/bem.js';
import Throttle from '@scripts/utilities/throttle.js';

import CMSContent from '../CMSContent/index.jsx';

import { isColumnSorted, showColumn } from './columns.jsx';


class Table extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      canScrollLeft: false,
      canScrollRight: false
    };

    this.tableContainerRef = React.createRef();
    this.tableRef = React.createRef();

    this.onResize = Throttle(this.onResize.bind(this), 500);
    this.onScroll = Throttle(this.onScroll.bind(this), 250);
  }

  checkTableResponsive() {
    if (this.tableContainerRef.current && this.tableRef.current) {
      var containerBounds = this.tableContainerRef.current.getBoundingClientRect();
      var tableBounds = this.tableRef.current.getBoundingClientRect();

      if (tableBounds.right > (containerBounds.right + 5)) {
        if (! this.state.canScrollRight) {
          this.setState({ canScrollRight: true });
        }
      } else {
        if (this.state.canScrollRight) {
          this.setState({ canScrollRight: false });
        }
      }
      if (tableBounds.left < (containerBounds.left - 5)) {
        if (! this.state.canScrollLeft) {
          this.setState({ canScrollLeft: true });
        }
      } else {
        if (this.state.canScrollLeft) {
          this.setState({ canScrollLeft: false });
        }
      }
    }
  }

  onResize() {
    this.checkTableResponsive();
  }

  onScroll() {
    this.checkTableResponsive();
  }

  componentDidMount() {
    this.checkTableResponsive();
    window.addEventListener('resize', this.onResize);
  }

  componentDidUpdate() {
    this.checkTableResponsive();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  render() {
    var rows = [];
    var header;

    var columnSetting = this.props.columnSetting;

    if (this.props.showHeader) {
      var tmp = [];
      for (var i = 0; i < this.props.columns.length; i++) {
        var column = this.props.columns[i];

        if (showColumn(columnSetting, column)) {
          tmp.push(
            <column.HeaderColumn
              key={column.id}
              setSort={this.props.setSort}
              sort={isColumnSorted(this.props.sort, column.id)}
            />
          );
        }
      }

      header = (
        <thead>
          <tr>{tmp}</tr>
        </thead>
      );
    }

    if (this.props.rows && this.props.rows.length) {
      for (var i = 0; i < this.props.rows.length; i++) {
        var row = this.props.rows[i];

        var tmp = [];
        for (var j = 0; j < this.props.columns.length; j++) {
          var column = this.props.columns[j];

          if (showColumn(columnSetting, column)) {
            tmp.push(
              <column.DetailColumn
                key={column.id}
                row={row}
              />
            );
          }
        }

        rows.push(
          <tr key={row.id || `tr-${rows.length + 1}`} className={row.selected ? 'selected' : ''}>
            {tmp}
          </tr>
        );
      }
    }

    if(!rows.length) {
      const totalColumn = this.props.columns.filter(col => showColumn(columnSetting, col));
      rows.push(<tr key="no-data-row">
        <td className='text-center' colSpan={totalColumn.length}>
          { this.props.noDataPlaceHolder || 'No data available' }
        </td>
      </tr>)
    }

    var variants = [];
    if (this.state.canScrollLeft) {
      variants.push('can-scroll-left');
    }
    if (this.state.canScrollRight) {
      variants.push('can-scroll-right');
    }


    return (
      <div className={BEM.classString('cs-asset-table', variants)}>
        <CMSContent>
          <figure ref={this.tableContainerRef} className="wp-block-table is-style-stripes" onScroll={this.onScroll}>
            <table ref={this.tableRef}>
              {header}
              <tbody>{rows}</tbody>
            </table>
          </figure>
        </CMSContent>
      </div>
    );
  }
}


Table.propType = {
  columns: PropTypes.array,
  columnSetting: PropTypes.string,
  rows: PropTypes.array,
  showHeader: PropTypes.bool,
  sort: PropTypes.string,
  setSort: PropTypes.func
};


export default Table;

